import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'business-list.list-view.category-cell.edit-category-cell.placeholder',
		defaultMessage: 'Add category',
		description: 'Placeholder for category field',
	},
	createNewCategory: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-new-category',
		defaultMessage: 'New category',
		description: 'Text appearing next to the new category name being created',
	},
	noMatches: {
		id: 'business-list.list-view.category-cell.edit-category-cell.no-matches',
		defaultMessage: 'No matches found',
		description: 'Message to show when there are no categories found',
	},
	noMatchesContactAdmin: {
		id: 'business-list.list-view.category-cell.edit-category-cell.no-matches-contact-admin',
		defaultMessage:
			"No category found. {br}{br}To add a category in this project, you'll need to {contactAdminLink}.",
		description: 'Message to show when there are no categories found and the user is not an admin.',
	},
	contactAdminLink: {
		id: 'business-list.list-view.category-cell.edit-category-cell.contact-admin-link',
		defaultMessage: 'contact your admin',
		description: 'Link to contact admin',
	},
});
